export interface ImportAnnotationConflict {
  imageName: string;
  dataSetName: string;
  decision: ResolveConflictDecision;
}

export enum ResolveConflictDecision {
  keepOriginal = 10,
  replaceAnnotation = 20,
}
